export default "/images/6ecbedd8f7f87c5548cdd92d0188fb76.avif";